<template>
    <div>
        <div class="call-participants__logo">
            <el-image class="call-screen__logo-image" v-if="image" :src="image" fit="contain"/>
            <div class="call-screen__logo-text" v-else>
                <h2>{{ brand }}</h2>
            </div>
        </div>
        <div class="call-participants__presentation">{{ name }}</div>
        <div class="call-participants__phone">{{ phone }}</div>
    </div>
</template>

<script>

  export default {
    props: {
      conversation: Object,
      role: String,
      direction: String,
    },

    computed: {
      /**
       * @return {object}
       */
      contactData() {
        const {
          full_name,
          filemaker_id,
          phone_number,
        } = this.conversation.contact || {};

        const name = filemaker_id
          ? `(${filemaker_id || ''}) ${full_name || ''}`
          : `${full_name || ''}`;

        return {
          name: name.trim(),
          phone: `${phone_number || ''}`.trim(),
          image: `/images/static/user.png`,
          brand: '',
        };
      },

      /**
       * @return {object}
       */
      outgoingNumberData() {
        const {
          presentation,
          phone_number,
          brand: {title, logo}
        } = this.conversation.outgoing_number || {};

        return {
          name: `${presentation || ''}`.trim(),
          phone: `${phone_number || ''}`.trim(),
          image: logo || '',
          brand: title || '',
        };
      },

      /**
       * @return {array}
       */
      path() {
        return [this.direction, this.role];
      },

      /**
       * @return {object}
       */
      part() {
        const name = _.get({
          inbound: {caller: 'contactData', callee: 'outgoingNumberData'},
          outbound: {caller: 'outgoingNumberData', callee: 'contactData'},
        }, this.path, null);

        return name ? this[name] : {};
      },

      /**
       * @return {string}
       */
      name() {
        return _.get(this.part, 'name', '');
      },

      /**
       * @return {string}
       */
      phone() {
        return _.get(this.part, 'phone', '');
      },

      /**
       * @return {string}
       */
      image() {
        return _.get(this.part, 'image', '');
      },

      /**
       * @return {string}
       */
      brand() {
        return _.get(this.part, 'brand', '');
      },
    },
  }
</script>
